import { render, staticRenderFns } from "./createActivity.vue?vue&type=template&id=dd62db42&scoped=true"
import script from "./createActivity.vue?vue&type=script&lang=js"
export * from "./createActivity.vue?vue&type=script&lang=js"
import style0 from "./createActivity.vue?vue&type=style&index=0&id=dd62db42&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd62db42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城商家端\\fhj-web-dyh-mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd62db42')) {
      api.createRecord('dd62db42', component.options)
    } else {
      api.reload('dd62db42', component.options)
    }
    module.hot.accept("./createActivity.vue?vue&type=template&id=dd62db42&scoped=true", function () {
      api.rerender('dd62db42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/group/groupActivity/createActivity.vue"
export default component.exports